module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-efficiency.c2062bd1.png";